module.exports = __webpack_public_path__ + "img/header1.015e20f2.png";